import { useNavigate } from 'react-router-dom';
import { Zap } from 'lucide-react';

export default function UpgradeBanner() {
  const navigate = useNavigate();

  return (
    <div
      className="w-full flex items-center justify-between px-6 py-2.5 border-b"
      style={{
        background: 'linear-gradient(90deg, rgba(196,122,10,0.12) 0%, rgba(232,160,32,0.18) 50%, rgba(196,122,10,0.12) 100%)',
        borderColor: 'rgba(232,160,32,0.3)',
      }}
      data-testid="upgrade-banner"
    >
      <div className="flex items-center gap-2.5">
        <Zap className="w-3.5 h-3.5 shrink-0" style={{ color: '#E8A020' }} />
        <span className="text-xs font-mono" style={{ color: '#E8A020' }}>
          You&rsquo;re on the Spark plan &mdash; unlock the full story engine.
        </span>
      </div>
      <button
        onClick={() => navigate('/upgrade')}
        className="text-xs font-mono uppercase tracking-widest px-4 py-1.5 border shrink-0 hover:opacity-80 transition-opacity"
        style={{
          color: '#E8A020',
          borderColor: 'rgba(232,160,32,0.5)',
          background: 'rgba(232,160,32,0.1)',
        }}
        data-testid="upgrade-banner-cta"
      >
        Upgrade Now
      </button>
    </div>
  );
}
